var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal-fade"}},[_c('div',{staticClass:"modal-backdrop"},[_vm._t("modal-content",[_vm._v(" This is the default content! ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }